import { createBrowserRouter } from 'react-router';
import { setUnauthenticatedHandler, queryClient } from '@/lib/api/instance';
import { UNGUARDED_NAVIGATION } from '@/lib/navigation';
import { routes } from './routes';
import { redirectToLogin } from './unauthenticated';

export const router = createBrowserRouter(routes);

setUnauthenticatedHandler(() => {
  redirectToLogin(
    queryClient,
    window.location,
    (to) => void router.navigate(to, { replace: true, state: UNGUARDED_NAVIGATION }),
  );
});
